<template>
  <div class="achievement-preview">
    <el-form  label-position="left" inline  :model="form" size="small">
      <el-form-item >
        <el-input v-model="form.name" placeholder="请输入成果名称" @input="handleInput"></el-input>
      </el-form-item>
      <el-form-item >
        <el-select filterable clearable v-model="form.recommend_state" placeholder="请选择推荐状态" @change="handleSelectChange">
          <el-option label="待推荐" value="0"></el-option>
          <el-option label="已推荐" value="1"></el-option>
          <el-option label="已驳回未推荐" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item  >
        <el-date-picker
      v-model="dateValue"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      @change="handleDateChange">
    </el-date-picker>

      </el-form-item>


    </el-form>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="custom-table">
      <el-table-column prop="name" width="280" label="成果名称" align="center"> </el-table-column>
      <el-table-column prop="recommend_state"  width="100" label="推荐状态" align="center"> 
        <template slot-scope="scope">
          <span v-if="scope.row.recommend_state == 0">待推荐</span>
          <span v-if="scope.row.recommend_state == 1">已推荐</span>
          <span v-if="scope.row.recommend_state == 2">已驳回未推荐</span>
        </template>
      </el-table-column>
      <el-table-column prop="add_date"  width="100" label="数据状态" align="center">
       <template slot-scope="scope">
          <span >{{scope.row.is_save==2?'已提交':'暂存'}}</span>

        </template>
       </el-table-column>

      <el-table-column prop="up_date"  width="200" label="更新时间" align="center"> </el-table-column>
      <el-table-column prop="add_date"  width="200" label="提交时间" align="center"> </el-table-column>
      <el-table-column prop="date" width="200" label="操作" align="center" fixed="right"> 
        <template slot-scope="scope">
        
          <el-button type="text" size="small" @click="handleRow(scope.row,'download')">下载</el-button>
          <el-button type="text" size="small" v-if="scope.row.recommend_state != 1" @click="handleRow(scope.row,'edit')">编辑</el-button>
          <el-button type="text" size="small" v-if="scope.row.is_issue_cer == 1"  @click="handleRow(scope.row,'look')">查看证书</el-button>
          <el-button type="text" size="small" @click="handleRow(scope.row,'del')">删除</el-button>
        </template>
      </el-table-column>

    </el-table>
    <div class="paginBox">
      <div class="countNumber">
        共{{ total }}条
      </div>
      <div class="rightPagin">
        <el-pagination @size-change="sizePagination" :current-page="filter.currPage" @current-change="currentPagination"
          :page-size="filter.pageSize" background layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 详情弹框 -->
    <AchievementDetailDialog ref="detailDialog" @success="handleRefresh" />
  </div>
</template>

<script>
import AchievementDetailDialog from '@/views/bgManage/components/AchievementDetailDialog.vue'
import { getBaseUrl } from '@/config'

export default {
  name: 'AchievementPreview',
  components: {
    AchievementDetailDialog
  },
  data() {
    return {
      total:0,
      dateValue:'',
      currentRow:{},
      form:{
        name:'',
        recommend_state:'',
        updateTime:'',
        submissionTime:'',
      },
      filter:{
        currPage:1,
        pageSize:8,
        name:'',
        start_date:'',
        end_date:'',
      },
      checkDate:{},
      tableData:[],
      debounceTimer: null,
      baseURL: getBaseUrl()
    }
  },
  created() {
    this.getList();
    // this.getCheckDate();
  },
  methods: {
      getCheckDate(){
      this.$API.getCurrGames().then(res => {
        console.log("res=========", res);
        this.checkDate = res.data
      })
    },
    handleRefresh() {
      // 刷新列表
      this.filter.currPage = 1
      this.getList()
    },
    sizePagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    currentPagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    handleRow(row,type){
      switch(type){
        case 'download':
      window.open(`${this.baseURL}/frontend/opinion/projectPdf?token=${window.sessionStorage.getItem('token')}&xid=${row.xid}`);
          break;
              case 'look':
      window.open(`${row.cer_url}`);
          break;
        case 'edit':
          // if(this.checkDate.id !=row.game_id){
          //   this.$message.warning('不能修改非当前赛事的内容')
          //   return
          // }
          this.$refs.detailDialog.open(row.xid)
          break;
        case 'del':
        this.deleteAchievement(row.xid)
        break;
      }
    },
    deleteAchievement(id){
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$API.deleteAchievement({xid:id}).then(res=>{
            this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.filter.currPage = 1;
          this.getList()
      })
    
        }).catch(() => {
               
        });
    
    },
    // 输入框防抖处理
    handleInput() {
      // 清除之前的定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      // 设置新的定时器，500ms 后执行搜索
      this.debounceTimer = setTimeout(() => {
        this.handleFilterChange()
      }, 500)
    },
    // 选择框变化时立即搜索
    handleSelectChange() {
      this.handleFilterChange()
    },
    // 日期选择器变化时立即搜索
    handleDateChange() {
      this.handleFilterChange()
    },
    // 统一处理筛选变化
    handleFilterChange() {
      console.log(this.filter);
      this.filter.currPage = 1;
      this.filter.name = this.form.name;
      this.filter.recommend_state = this.form.recommend_state;
      this.filter.start_date = this.dateValue ? this.dateValue[0] : '';
      this.filter.end_date = this.dateValue ? this.dateValue[1] : '';
      this.getList();
    },
    getList() {
      this.$API.getAchievementList(this.filter).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.pageInfo.allRows;
      })
    }
  } 
}
</script>

<style lang="scss" scoped>
::v-deep .el-table th.el-table__cell{
  background: #F2F5FB !important;
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #595959;

}

.countNumber {
font-family: Microsoft YaHei, Microsoft YaHei;
font-weight: 400;
font-size: 14px;
color: #515A6E;
}
.paginBox {
display: flex;
justify-content: end;
padding: 0 20px 20px 0;
align-items: center;
margin-top: 20px;
width: 100%;
}

::v-deep .el-pagination.is-background .btn-prev {
background: none;
}

::v-deep .el-pagination .btn-next .el-icon {
font-size: 18px;
}

::v-deep .el-pagination .btn-prev .el-icon {
font-size: 18px;
}

::v-deep .btn-next {
width: 36px;
height: 36px;
background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}

::v-deep .btn-prev {
width: 36px;
height: 36px;
background-color: #FFFFFF !important;
border-radius: 3px 3px 3px 3px;
border: 1px solid #E5E5E5;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
background: #FFFFFF;
border-radius: 3px 3px 3px 3px;
border: 1px solid #2F86FF;
font-weight: 400;
font-size: 14px;
color: #2F86FF;
text-align: center;
font-style: normal;
text-transform: none;
}

::v-deep .el-pagination.is-background .el-pager li {
border-radius: 3px 3px 3px 3px;
border: 1px solid #B4B4B4;
background: none;
width: 36px;
height: 36px;
font-weight: 400;
font-size: 14px;
color: #313131;
text-align: center;
font-style: normal;
text-transform: none;
line-height: 35px;
}
</style>
